<template>
    <v-card>
        <v-toolbar dark class="cyan darken-3">
            <v-toolbar-title>Documentos</v-toolbar-title>
        </v-toolbar>
        <v-list>
            <v-list-tile v-for="document in documents" :key="document.name" @click="genTokenAndDownload(document)">
                <v-list-tile-action>
                    <v-icon color="success" v-if="document.type != 'ata' || document.url">file_download</v-icon>
                    <v-icon color="info" v-else>add</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                    <div class="body-1">
                        {{ document.name }}
                        <v-chip label small class="cyan darken-3 white--text" v-if="document.params.role">{{ document.params.role }}</v-chip>
                    </div>
                </v-list-tile-content>
            </v-list-tile>
        </v-list>
        <v-flex xs12 v-if="showMinutesConfirmation">
            <v-card xs12>
                <v-toolbar dark class="info darken-3">
                    <v-toolbar-title>Ata da Banca</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn color="info" icon @click="showMinutesConfirmation = false">
                        <v-icon dark>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    As informações da banca <strong class="red--text">não poderão</strong> ser alteradas após a emissão da ata.
                </v-card-text>
                <v-card-text>
                    <v-btn dark color="info" @click="previewMinutes">
                        <v-icon left dark>pageview</v-icon> Pré-visualizar
                    </v-btn>
                    <v-btn dark color="info" @click="openURL(previewURL)" v-if="previewURL">
                        <v-icon left dark>refresh</v-icon> Clique aqui caso a pré-visualização da ata não tenha sido exibida
                    </v-btn>
                    <v-btn dark color="success" @click="generateMinutes">
                        <v-icon left dark>check</v-icon> Emitir
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-flex>
        <v-card-title v-if="errors != false">
            <v-alert color="error" value="true" v-for="(error, idx) in errors" :key="'error_'+idx">
                {{ error }}
            </v-alert>
        </v-card-title>
        <v-card-actions v-if="showActions">
            <slot name="actions"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
    export default {
        name: 'ExamDocuments',
        props: {
            examId: {
                type: [Number, String],
                default: ''
            },
            teachers: {
                type: [Array, String],
                default: ''
            }
        },
        data() {
            return {
                documentTypes: [],
                documents: [],
                showActions: false,
                showMinutesConfirmation: false,
                previewURL: null,
                errors: false
            }
        },
        methods: {
            emitirDocumentos: function (bancaId) {
                this.$http.post('emitirDocumentos', {
                    bancaId
                }).then(response => {
                    console.log('sucesso');
                }, response => {
                    console.log('erro');
                    console.log(response);
                });
            },
            getDocumentTypes: function () {
                if (this.examId) {
                    this.$http.post('listDocumentTypes', {}).then(response => {
                        this.documentTypes = response.body
                        this.getDocuments()
                    });
                } else {
                    this.documentTypes = []
                    this.documents = []
                }
            },
            getDocuments: function () {
                let documents = []
                for (let key in this.documentTypes) {
                    let documentType = this.documentTypes[key]
                    if (['autorizacao_publicacao', 'lista_presenca'].includes(key)) {
                        documents.push({
                            type: key,
                            name: documentType.name,
                            params: { document: 'trabalho final'},
                            token: '',
                            url: null
                        })
                    }
                    /*
                    if (key == 'declaracoes_participacao') {
                        documents.push({
                            type: key,
                            name: documentType.name,
                            params: { },
                            token: ''
                        })
                    }
                    /*
                    if (key == 'declaracao_participacao') {
                        for (let tkey in this.teachers) {
                            let teacher = this.teachers[tkey]
                            if (tkey && tkey != 'remove' && teacher) {
                                documents.push({
                                    type: key,
                                    name: documentType.name + ' - ' + teacher.name,
                                    params: { role: teacher.role, teacher: teacher.id },
                                    token: ''
                                })
                            }
                        }
                    }
                    */
                }
                this.documents = documents
                this.checkExamHasMinutes()
            },
            checkExamHasMinutes: function () {
                this.$http.post('checkExamMinutes', { exam: this.examId }).then(response => {
                    if (response.status == 200) {
                        let name = 'Ata da Banca (Pendente)',
                            url = null
                        if (!!response.data.minutes && typeof response.data.minutes.url != 'undefined') {
                            name = 'Ata da Banca'
                            url = response.data.minutes.url
                        }
                        this.documents.push({
                            type: 'ata',
                            name: name,
                            params: { },
                            token: '',
                            url: url
                        })
                    }
                }, response => {
                    console.error('Não foi possível consultar a ata da banca')
                    console.debug(response)
                })
            },
            genTokenAndDownload: function (document) {
                if (document.token) {
                    // TODO remove quote
                    //this.download(document)
                    //return
                }
                if (document.type == 'ata') {
                    if (document.url) {
                        this.openURL(document.url)
                    } else {
                        this.showMinutesConfirmation = true
                    }
                    return
                }
                this.$http.post('createDocument', { type: document.type, exam: this.examId, params: document.params }).then(response => {
                    if (response.status == 200) {
                        Object.values(response.data.token).forEach((el, i) => {
                            document.token = el
                            this.download(document)
                        });

                        /*
                        response.data.token.forEach(element =>  {
                            document.token = element
                            this.download(document)
                        });
                        */
                    } else {
                        console.error('Não foi possível gerar o documento')
                        console.debug(response)
                    }
                }, response => {
                    console.error('Não foi possível gerar o documento')
                    console.debug(response)
                })
            },
            download: function (document) {
                let url = this.$http.options.root + 'documentos.php?token=' + document.token
                this.openURL(url)
            },
            openURL: function (url) {
                window.open(url, '_blank')
            },
            getMinutes: function (demo) {
                let _this = this;
                this.errors = false
                this.previewURL = null
                this.$http.post('generateMinutes', { exam: this.examId, demo: demo }).then(response => {
                    if (response.data.status == 'ok') {
                        if (!!response.data.minutes && typeof response.data.minutes.url !== 'undefined') {
                            if (!demo) {
                                for (let key in this.documents) {
                                    let document = this.documents[key]
                                    if (document.type == 'ata') {
                                        this.documents[key].name  = 'Ata da Banca'
                                        this.documents[key].url  = response.data.minutes.url
                                        this.showMinutesConfirmation = false

                                        // dispara email para aluno e professor
                                        setTimeout(function () {
                                            _this.emitirDocumentos(_this.examId)
                                        }, 1500)

                                        break
                                    }
                                }
                            } else {
                                this.previewURL = response.data.minutes.url
                            }
                            this.openURL(response.data.minutes.url)
                        }
                    } else {
                        console.error('Não foi possível gerar a ata')
                        console.debug(response)
                        if (typeof response.data.errors != 'undefined') {
                            this.errors = response.data.errors
                        }
                    }
                }, response => {
                    console.error('Não foi possível gerar a ata')
                    console.debug(response)
                    if (typeof response.data.errors != 'undefined') {
                        this.errors = response.data.errors
                    }
                });
            },
            previewMinutes: function () {
                this.getMinutes(true)
            },
            generateMinutes: function () {
                this.getMinutes(false)
            }
        },
        watch: {
            examId: function (newValue) {
                this.getDocumentTypes()
            }
        },
        created: function () {
            this.showActions = typeof this.$slots['actions'] !== 'undefined'
            this.getDocumentTypes()
        }
    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// ExamDocuments.vue?f69c8864